function updateSettings(value, url) {
    if (value) {
        const data = {
            payload: value
        };

        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            data: data
        });
    }
}

function updateLogSettings(value, url) {
    if (value) {
        const data = {
            userActivityLogRotationDays: value
        };

        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            data: data
        });
    }
}

function updateLabelSettings(value, url) {
    if (value) {
        const data = {
            label_expiration_days: value
        };

        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            data: data
        });
    }
}

function toggleMultiPackageLabelFields() {
    const isEnabled = $('#enable_multi_package_label').is(':checked');
    const dependentFields = $('#multi_package_label_dependent_fields');

    if (isEnabled) {
        // Enable all fields
        dependentFields.find('input, textarea').prop('disabled', false);
        dependentFields.css('opacity', '1');
    } else {
        // Disable all fields
        dependentFields.find('input, textarea').prop('disabled', true);
        dependentFields.css('opacity', '0.5');
    }
}

function updateMultiPackageLabelSettings() {
    const data = {
        label_expiration_days: $('input[name="label_expiration_days"]').val(),
        enable_multi_package_label: $('#enable_multi_package_label').is(':checked') ? '1' : '0',
        multi_package_label_message: $('#multi_package_label_message').val(),
        show_order_number_on_multi_package_label: $('#show_order_number_on_multi_package_label').is(':checked') ? '1' : '0',
        show_tracking_numbers_on_multi_package_label: $('#show_tracking_numbers_on_multi_package_label').is(':checked') ? '1' : '0'
    };

    $.ajax({
        url: '/settings/label/update',
        type: 'get',
        dataType: 'json',
        data: data,
    });
}

function updateShipstationSettings(url) {
    const data = {
        enabled: $('#shipstation_enabled').is(':checked') ? '1' : '0',
        API_key: $('#shipstation_API_key').val(),
        API_secret: $('#shipstation_API_secret').val(),
    };

    $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        data: data
    });
}

function updateVeeqoSettings(url) {
    const data = {
        enabled: $('#veeqo_enabled').is(':checked') ? '1' : '0',
        api_key: $('#veeqo_api_key').val(),
        notify_customer: $('#veeqo_notify_customer').is(':checked') ? '1' : '0',
        notify_remote: $('#veeqo_notify_remote').is(':checked') ? '1' : '0',
    };

    $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        data: data
    });
}


function toggleNotificationStatus(statusDivId, isChecked) {
    if (isChecked) {
        $(`#${statusDivId}`).removeClass('d-none');
    } else {
        $(`#${statusDivId}`).addClass('d-none');
        $(`#${statusDivId} input[type="checkbox"]`).prop('checked', false);
    }
}

function checkNotificationStatus(statusGroupName, warningId) {
    const checkedCount = $(`input[id^="${statusGroupName}_"]`).filter(':checked').length;

    if (checkedCount === 0) {
        $(`#${warningId}`).removeClass('d-none');
    } else {
        $(`#${warningId}`).addClass('d-none');
    }
}

function updateUPSSettings(url) {
    const ups_notify_user = $('#ups_notify_user').is(':checked');
    const ups_notify_shipper = $('#ups_notify_shipper').is(':checked');

    const notifyUserStatus = $('input[name="ups_notify_user_status[]"]:checked').map(function () {
        return $(this).val();
    }).get();

    const notifyShipperStatus = $('input[name="ups_notify_shipper_status[]"]:checked').map(function () {
        return $(this).val();
    }).get();

    if (ups_notify_user && notifyUserStatus.length === 0) {
        $('#ups_notify_user_warning').removeClass('d-none');
    } else {
        $('#ups_notify_user_warning').addClass('d-none');
    }

    if (ups_notify_shipper && notifyShipperStatus.length === 0) {
        $('#ups_notify_shipper_warning').removeClass('d-none');
    } else {
        $('#ups_notify_shipper_warning').addClass('d-none');
    }

    const data = {
        notify_user: ups_notify_user ? '1' : '0',
        notify_shipper: ups_notify_shipper ? '1' : '0',
        notify_user_status: ups_notify_user ? notifyUserStatus : [],
        notify_shipper_status: ups_notify_shipper ? notifyShipperStatus : []
    };

    if ($('#ups_enabled').length) {
        data.enabled = $('#ups_enabled').is(':checked') ? '1' : '0';
    }

    if ($('#ups_testing_mode').length) {
        data.testing_mode = $('#ups_testing_mode').is(':checked') ? '1' : '0';
    }

    if ($('#ups_client_id').length) {
        data.client_id = $('#ups_client_id').val();
    }

    if ($('#ups_client_secret').length) {
        data.client_secret = $('#ups_client_secret').val();
    }

    $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        data: data
    });
}

function updateFedExSettings(url) {
    const fedex_notify_user = $('#fedex_notify_user').is(':checked');
    const fedex_notify_shipper = $('#fedex_notify_shipper').is(':checked');

    const notifyUserStatus = $('input[name="notify_user_status[]"]:checked').map(function () {
        return $(this).val();
    }).get();

    const notifyShipperStatus = $('input[name="notify_shipper_status[]"]:checked').map(function () {
        return $(this).val();
    }).get();

    const data = {
        testing_mode: $('#fedex_testing_mode').is(':checked') ? '1' : '0',
        notify_shipper: fedex_notify_shipper ? '1' : '0',
        notify_user: fedex_notify_user ? '1' : '0',
        notify_user_status: fedex_notify_user ? notifyUserStatus : [],
        notify_shipper_status: fedex_notify_shipper ? notifyShipperStatus : [],
        // SmartPost/Ground Economy settings
        smartpost_hub_id: $('#smartpost_hub_id').val(),
        smartpost_indicia: $('#smartpost_indicia').val(),
        smartpost_ancillary_endorsement: $('#smartpost_ancillary_endorsement').val(),
        smartpost_customer_manifest_id: $('#smartpost_customer_manifest_id').val(),
        smartpost_client_id: $('#smartpost_client_id').val(),
    };

    if (fedex_notify_user) {
        $("#notify_user_status").removeClass("d-none");
    } else {
        $("#notify_user_status").addClass("d-none");
        $('input[name="notify_user_status[]"]').prop('checked', false);
    }

    if (fedex_notify_shipper) {
        $("#notify_shipper_status").removeClass("d-none");
    } else {
        $("#notify_shipper_status").addClass("d-none");
        $('input[name="notify_shipper_status[]"]').prop('checked', false);
    }

    $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        data: data
    });
}

function updateTrackerSettings(url) {
    const data = {
        trackerIntervalCount: $('#tracker_interval_count').val(),
    };

    $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        data: data
    });
}

function updateShippingSettings(url) {
    const data = {
        autoRate: $('#shipping_auto_rate').is(':checked') ? '1' : '0',
        pallet_based_shipping: $('#pallet_based_shipping').is(':checked') ? '1' : '0',
    };

    $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        data: data
    });
}

function updateAmazonS3Settings(url) {
    const data = {
        access_key: $('#amazon_access_key').val(),
        secret_key: $('#amazon_secret_key').val(),
        region: $('#amazon_region').val(),
        bucket: $('#amazon_bucket').val(),
    };

    $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        data: data
    });
}

function updateSlackLogSettings(url) {
    const data = {
        enabled: $('#slack_enabled').is(':checked') ? '1' : '0',
        webhook_url: $('#slack_webhook_url').val(),
        username: $('#slack_username').val(),
        emoji: $('#slack_emoji').val(),
        log_level: $('#slack_log_level').val(),
    };

    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: data,
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
}

// function toggleNotificationStatus(sectionId, isChecked) {
//     const section = document.getElementById(sectionId);
//     section.classList.toggle('d-none', !isChecked);
// }
// function checkNotificationStatus(sectionId, warningId) {
//     const checkboxes = document.querySelectorAll(`#${sectionId} input[type='checkbox']`);
//     const warning = document.getElementById(warningId);
//     const isChecked = Array.from(checkboxes).some(checkbox => checkbox.checked);
//     warning.classList.toggle('d-none', isChecked);
// }


window.updateLabelSettings = updateLabelSettings;
window.updateShipstationSettings = updateShipstationSettings;
window.updateVeeqoSettings = updateVeeqoSettings;
window.toggleNotificationStatus = toggleNotificationStatus;
window.checkNotificationStatus = checkNotificationStatus;
window.updateUPSSettings = updateUPSSettings;
window.updateFedExSettings = updateFedExSettings;
window.updateTrackerSettings = updateTrackerSettings;
window.updateShippingSettings = updateShippingSettings;
window.updateAmazonS3Settings = updateAmazonS3Settings;
window.updateSlackLogSettings = updateSlackLogSettings;
window.updateLogSettings = updateLogSettings;
window.updateMultiPackageLabelSettings = updateMultiPackageLabelSettings;
window.toggleMultiPackageLabelFields = toggleMultiPackageLabelFields;

// Initialize multi-package label fields state on page load
$(document).ready(function() {
    if ($('#enable_multi_package_label').length) {
        toggleMultiPackageLabelFields();
    }
});
